import React from 'react';

import '../../../styles/campaign-detail.scss';

import VideocamIcon from '@mui/icons-material/Videocam';

import CheckTick from '../../../../../Icons/icons/CheckTick';
import PostIcon from '../../../../../Icons/icons/PostIcon';
import ReelIcon from '../../../../../Icons/icons/ReelIcon';
import StoriesIcon from '../../../../../Icons/icons/StoriesIcon';
import TikTokFlatIcon from '../../../../../Icons/TikTokFlatIcon';
import YoutubeShortIcon from '../../../../../Icons/YoutubeShortIcon';
import { useCampaignDetail } from '../CampaignDetailProvider';

const instagramOptions = [
  {
    value: 'post',
    text: 'Instagram Posts',
    logo: <PostIcon color="currentColor" />,
  },
  {
    value: 'reel',
    text: 'Instagram Reels',
    logo: <ReelIcon color="currentColor" />,
  },
  {
    value: 'story',
    text: 'Instagram Stories',
    logo: <StoriesIcon color="currentColor" />,
  },
];

const youtubeOptions = [
  {
    value: 'ytVideo',
    text: 'Youtube Videos',
    logo: <VideocamIcon style={{ width: '16px', transform: 'scale(1.2)' }} />,
    disabled: true,
  },
  {
    value: 'ytShort',
    text: 'Youtube Shorts',
    logo: <YoutubeShortIcon color="currentColor" />,
    disabled: true,
  },
  {
    value: 'ytStory',
    text: 'Youtube Stories',
    logo: <StoriesIcon color="currentColor" />,
    disabled: true,
  },
];

const tiktokOptions = [
  {
    value: 'ttVideo',
    text: 'TikToks',
    logo: <TikTokFlatIcon color="currentColor" />,
  },
  // {
  //   value: 'ttStory',
  //   text: 'TikTok Stories',
  //   logo: <StoriesIcon color="currentColor" />,
  //   disabled: true,
  // },
];

export const allContentTypeOptions = [
  ...instagramOptions,
  ...tiktokOptions,
  // ...youtubeOptions,
];

const platformOptionsMap = {
  instagram: instagramOptions,
  youtube: youtubeOptions,
  tiktok: tiktokOptions,
};

const ContentTypeSelect = () => {
  const { selectedPlatformType, selectedContentType, setNewContentType } = useCampaignDetail();

  let options = [];

  if (selectedPlatformType === 'all') {
    options = [...options, ...allContentTypeOptions];
  } else {
    options = [...options, ...platformOptionsMap[selectedPlatformType]];
  }

  return (
    <div className="filter-select-container">
      <div className="filter-pill__options-container full-height">
        {options.map((option) => {
          const isSelected = selectedContentType === option.value;
          return (
            <div
              key={option.value}
              className={`filter-pill__option-item ${isSelected ? 'selected' : ''} ${
                option.disabled ? 'cursor-disabled' : ''
              }`}
              onClick={() => {
                if (option.disabled) return;
                if (isSelected) setNewContentType('all');
                else setNewContentType(option.value);
              }}>
              <div className="gap-2 flex items-center">
                {option.logo}
                <span className="filter-pill__option-item__text">{option.text}</span>
              </div>
              {isSelected && <CheckTick color="var(--purple-p-400)" />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ContentTypeSelect;
